import React from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import classNames from 'classnames';
import {
  components as DefaultSelectComponents,
  OptionProps,
} from 'react-select';
import { SelectOption } from '@lib/components/Select/types';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Chip, { ChipSizes } from '@lib/components/Chip/Chip';
import styles from '@lib/components/Select/Select.module.scss';
import getFormTemplateVersionStatusChipType from 'utils/getFormTemplateVersionStatusChipType';

function VersionOption({
  children,
  ...restProps
}: OptionProps): React.ReactElement {
  const { isSelected, isMulti, options } = restProps;
  const value = _get(restProps, 'value', '');
  const fullWidthMenu = _get(restProps, 'selectProps.fullWidthMenu');
  const selectedOption = _find(
    options,
    ({ value: optionValue }) => value === optionValue,
  ) as SelectOption;
  const { data } = selectedOption || {};
  const status = _get(data, 'status');
  return (
    // @ts-ignore
    <DefaultSelectComponents.Option
      {...restProps}
      className={classNames(
        styles.chipCircleOption,
        styles.entityOptionWithLeftIcon,
        {
          active: isSelected,
          [styles.optionWithCheckbox]: isMulti,
          [styles.optionOneLine]: fullWidthMenu === false,
        },
      )}
    >
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <span className={styles.chipOptionIcon}>
        <Chip
          leftIcon="circle"
          type={getFormTemplateVersionStatusChipType(status)}
          size={ChipSizes.smallLeftIconOnly}
        />
      </span>
      {children}
    </DefaultSelectComponents.Option>
  );
}

export default VersionOption;
